import React from "react";
import { Link } from "react-router-dom";

/*eslint-disable */
declare const window: any;

interface MenuVehiculosDetailComponentProps {
  selectedMenu: any;
  navigate: any;
  setSelectedMenu: any;
  data: any;
  visibleHeight: any;
  ficha_tecnica: any;
  menus: any;
  currentSection: any;
  vehiculo: any;
  topbar_design: any;
  topbar_gallery: any;
  topbar_models: any;
  topbar_technology: any;
  topbar_version: any;
}

const MenuVehiculosDetailComponent: React.FC<
  MenuVehiculosDetailComponentProps
> = ({
  selectedMenu,
  navigate,
  setSelectedMenu,
  data,
  visibleHeight,
  ficha_tecnica,
  menus,
  currentSection,
  vehiculo,
  topbar_design,
  topbar_gallery,
  topbar_models,
  topbar_technology,
  topbar_version,
}) => {
  // console.log(menus?.modelos);
  // console.log(topbar_models);

  return (
    <div
      className="menu-vehiculos-detail-component"
      style={visibleHeight <= 0 ? { top: `0px` } : {}}
    >
      <div className="title-menu-vehiculos-detail-component">{data?.title}</div>
      <div className="content-menu-vehiculos-detail-component">
        <div
          className={`individual-content-menu-vehiculos-detail-component ${
            selectedMenu === "cotizacion" ? "active" : ""
          }`}
          onClick={() => {
            navigate(`/vehiculos/${vehiculo}#cotizacion`);
            setSelectedMenu("cotizacion");
          }}
        >
          Cotización
        </div>

        <a
          href={ficha_tecnica}
          target="_blank"
          className={`individual-content-menu-vehiculos-detail-component ${
            selectedMenu === "ficha" /* || currentSection === "ficha" */
              ? "active"
              : ""
          }`}
          onClick={() => {
            navigate("#ficha");
            setSelectedMenu("ficha");
          }}
        >
          Ficha técnica
        </a>
        {menus?.motor && (
          <div
            className={`individual-content-menu-vehiculos-detail-component ${
              selectedMenu === "motor" /* || currentSection === "motor" */
                ? "active"
                : ""
            }`}
            onClick={() => {
              navigate(`/vehiculos/${vehiculo}#motor`);
              setSelectedMenu("motor");
            }}
          >
            Motor
          </div>
        )}

        <div
          className={`individual-content-menu-vehiculos-detail-component ${
            selectedMenu === "diseño" /* || currentSection === "diseño" */
              ? "active"
              : ""
          }`}
          onClick={() => {
            navigate(`/vehiculos/${vehiculo}#diseno`);
            setSelectedMenu("diseño");
          }}
        >
          {topbar_design}
        </div>
        {menus?.version && (
          <div
            className={`individual-content-menu-vehiculos-detail-component ${
              selectedMenu ===
              "versiones" /* || currentSection === "versiones" */
                ? "active"
                : ""
            }`}
            onClick={() => {
              navigate(`/vehiculos/${vehiculo}#versiones`);
              setSelectedMenu("versiones");
            }}
          >
            {topbar_version}
          </div>
        )}
        {menus?.galeria && (
          <div
            className={`individual-content-menu-vehiculos-detail-component ${
              selectedMenu === "galeria" /* || currentSection === "galeria" */
                ? "active"
                : ""
            }`}
            onClick={() => {
              navigate(`/vehiculos/${vehiculo}#galeria`);
              setSelectedMenu("galeria");
            }}
          >
            {topbar_gallery}
          </div>
        )}
        {menus?.tecnologia && (
          <div
            className={`individual-content-menu-vehiculos-detail-component ${
              selectedMenu === "tecnologia" ? "active" : ""
            }`}
            onClick={() => {
              navigate(`/vehiculos/${vehiculo}#tecnologia`);
              setSelectedMenu("tecnologia");
            }}
          >
            {topbar_technology}
          </div>
        )}
        {menus?.modelos && (
          <div
            className={`individual-content-menu-vehiculos-detail-component ${
              selectedMenu === "modelos" ? "active" : ""
            }`}
            onClick={() => {
              navigate(`/vehiculos/${vehiculo}#modelos`);
              setSelectedMenu("modelos");
            }}
          >
            {topbar_models}
          </div>
        )}
        <Link
          to={`/vehiculos/${vehiculo}/comparador`}
          className={`individual-content-menu-vehiculos-detail-component ${
            selectedMenu === "comparador" /* || currentSection === "modelos" */
              ? "active"
              : ""
          }`}
          onClick={() => {
            navigate("#comparador");
            setSelectedMenu("comparador");
          }}
        >
          Comparador
        </Link>
      </div>
      <div className="opciones-menu-vehiculos-detail-component">
        <Link
          to={`/simulador-de-cuotas/${data.modelo}`}
          className="simulador-opciones-menu-vehiculos-detail-component"
        >
          Simula tu cuota
        </Link>
        <Link
          to={`/vehiculos/${data?.modelo}#cotizacion`}
          className="cotiza-opciones-menu-vehiculos-detail-component"
        >
          Cotiza
        </Link>
      </div>
    </div>
  );
};

export default MenuVehiculosDetailComponent;
